import script from "./UserSearchSmart.vue?vue&type=script&setup=true&lang=js"
export * from "./UserSearchSmart.vue?vue&type=script&setup=true&lang=js"

import "./UserSearchSmart.vue?vue&type=style&index=0&id=5362e7fd&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5362e7fd"]])

export default __exports__